import React from 'react';
import {
  StapleTable,
  StapleTableBody,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
} from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { File } from 'types/policyService';
import FileTableRow from './TableRow';

interface Props {
  loading: boolean;
  filesList: File[];
}

const FileTable: React.FC<Props> = observer(({ loading, filesList }) => {
  return (
    <StapleTable loading={loading} totalElements={filesList.length}>
      <StapleTableHeader>
        <StapleTableRow>
          <StapleTableHeading width="60%">Name</StapleTableHeading>
          <StapleTableHeading width="30%">Signature Requested</StapleTableHeading>
          <StapleTableHeading width="10%" />
        </StapleTableRow>
      </StapleTableHeader>
      <StapleTableBody>
        {filesList.map((file, index) => (
          <FileTableRow file={file} key={file.id} fileIndex={index + 1} />
        ))}
      </StapleTableBody>
    </StapleTable>
  );
});

export default FileTable;
